export default __webpack_public_path__ + "static/media/stm_layout_bottom.cbacdc39.svg";